import isEmpty from 'lodash/isEmpty';

import ParticipantService from '../../Participants/api/ParticipantService';

const checkIsValidBuyer = async (
  baseApiUrl,
  eventEditionId,
  interfaceLocale
) => {
  let isValidBuyer = false;

  isValidBuyer = await ParticipantService.getFeatureFilters(
    baseApiUrl,
    eventEditionId,
    interfaceLocale
  ).then((response) => {
    if (!isEmpty(response.participantFeatureFilters)) {
      return (
        window.featureFilters &&
        response.participantFeatureFilters.find(
          (ff) => ff.featureFilterId === window.featureFilters.certifiedBuyerId
        ) !== undefined
      );
    }

    return false;
  });

  return isValidBuyer;
};

const getUnrestrictedFeatureFilter = async (
  baseApiUrl,
  eventEditionId,
  interfaceLocale
) => {
  let unrestrictedFeatureFilter = null;

  unrestrictedFeatureFilter = await ParticipantService.getFeatureFilterName(
    baseApiUrl,
    eventEditionId,
    interfaceLocale
  ).then((unrestrictedFeatureFilterResponse) => {
    if (unrestrictedFeatureFilterResponse.items?.length > 0) {
      return unrestrictedFeatureFilterResponse.items.find(
        (ff) =>
          window.featureFilters &&
          ff.id === window.featureFilters.certifiedBuyerId
      ) ?? null;
    }

    return null;
  });

  return unrestrictedFeatureFilter;
};

export default { checkIsValidBuyer, getUnrestrictedFeatureFilter };
